import React, { useEffect } from 'react';
import { InfluencerPartnershipContainer } from '../../components/Influencer/InfluencerPartnershipContainer';
import { setBuzzBridgeSignupContext } from '../../utils/buzzbridgeAppContext';

export const BuzzBridgeLandingPage: React.FC = () => {
    useEffect(() => {
        setBuzzBridgeSignupContext(true);
    }, []);

    return <InfluencerPartnershipContainer isLandingPage />;
};
